import React, { ReactElement, useCallback } from 'react';
import * as css from './CampaignPanel.module.scss';
import 'src/css/themes.scss';
import { CheckedCAMPAIGN, ConnectedVehicleRec, ImportedCAMPAIGN } from 'src/models';
import { Checkbox, Link } from '@framework-controls/core';
import IconError from 'src/content/icons/Error.svg';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    checkedCampaign: CheckedCAMPAIGN[];
    importedCampaign: ImportedCAMPAIGN[];
    mode: string;
    index: number;
    lastCamp: string;
    toggleCampaign: (code: string) => void;
}

const CampaignPanel = (props: IProps) => {
    const campaignChecked = props.checkedCampaign.some(result => (result.code ===
        props.connectedVehicle.campaign[props.index].code) ? true : false);
    const toggleCampaign = useCallback(() => {
        props.toggleCampaign(props.connectedVehicle.campaign[props.index].code);
    }, [props.toggleCampaign, props.index, props.connectedVehicle.campaign]);
    const isTMNA = ((props.connectedVehicle.parentMake === 'TY' || props.connectedVehicle.parentMake === 'LX') ? true : false);
    const campaignDisabled = ((isTMNA && (props.connectedVehicle.campaign[props.index].remedyAvailable) !== 'Y') ? true : false);

    let stopSaleIcon: ReactElement | null = null;
    if (props.connectedVehicle.campaign[props.index].stopSale === 'Y') {
        stopSaleIcon =
            <img
                className={css.errorImage}
                alt=''
                src={IconError}>
            </img>;
    }

    let campaignCheckBox: ReactElement = <div className={css.checkboxArea}></div>;

    if (props.mode !== 'P') {
        if (props.importedCampaign.findIndex((result => result.code === props.connectedVehicle.campaign[props.index].code)) !==
        -1) {
            campaignCheckBox =
                <div className={css.checkboxArea}>
                    <div>
                        <Checkbox
                            id={'campaignCheckbox'}
                            size={'sm'}
                            variant={'primaryCkb'}
                            checked={campaignChecked}
                            onChange={toggleCampaign}>
                        </Checkbox>
                    </div>
                    <div className={css.asterisk}>*</div>
                </div>;
        } else {
            campaignCheckBox =
                <div className={css.campIcon}>
                    <Checkbox
                        id={'campaignCheckbox'}
                        size={'sm'}
                        variant={'primaryCkb'}
                        checked={campaignChecked}
                        onChange={((isTMNA && campaignDisabled) ? undefined : toggleCampaign)}
                        disabled={((isTMNA && campaignDisabled) ? true : undefined)}
                        tooltip={((isTMNA && campaignDisabled) ? strings.RemedyNotAvailable : undefined)}>
                    </Checkbox>
                </div>;
        }
    }

    return (
        <div>
            <div className={css.dataRow}>
                {campaignCheckBox}
                <div className={css.campDesc}>{props.connectedVehicle.campaign[props.index].desc}</div>
                <div className={css.campCode}>{props.connectedVehicle.campaign[props.index].code}</div>
                <div className={css.campRemedy}>{props.connectedVehicle.campaign[props.index].remedy}</div>
                <div className={css.campStopSale}>
                    <div>{stopSaleIcon}</div>
                    <div>{props.connectedVehicle.campaign[props.index].stopCode}</div>
                </div>
                <div className={css.campStartDate}>{props.connectedVehicle.campaign[props.index].startDate}</div>
                <div className={css.campRecallBulletin}>
                    <div className={props.connectedVehicle.campaign[props.index].recallUrl ? css.hidden : css.campRecallIdNoLink}>
                        {props.connectedVehicle.campaign[props.index].recallId}
                    </div>
                    <Link
                        id='RecallLink'
                        url={props.connectedVehicle.campaign[props.index].recallUrl}
                        className={props.connectedVehicle.campaign[props.index].recallUrl ? css.campRecallId : css.hidden}
                    >
                        <div>{props.connectedVehicle.campaign[props.index].recallId}</div>
                    </Link>
                    <div className={props.connectedVehicle.campaign[props.index].bulletinUrl ? css.hidden : css.campBullIdNoLink}>
                        {props.connectedVehicle.campaign[props.index].bulletinId}
                    </div>
                    <Link
                        id='BulletinLink'
                        url={props.connectedVehicle.campaign[props.index].bulletinUrl}
                        className={props.connectedVehicle.campaign[props.index].bulletinUrl ? css.campBullId : css.hidden}
                    >
                        <div>{props.connectedVehicle.campaign[props.index].bulletinId}</div>
                    </Link>
                </div>
                <div className={css.campReservedBy}>{props.connectedVehicle.campaign[props.index].reservedBy}</div>
                <div className={css.campStatus}>{props.connectedVehicle.campaign[props.index].status}</div>
                <div className={css.campPartsRepairTime}>
                    <div>{props.connectedVehicle.campaign[props.index].partsReq}</div>
                    <div>{props.connectedVehicle.campaign[props.index].repairTime}</div>
                </div>
            </div>
            <hr className={props.connectedVehicle.campaign[props.index].code === props.lastCamp ? css.hidden : css.dataLine}></hr>
        </div>
    );
};

export default CampaignPanel;